import styled from "styled-components/native";
import { DistributionType, ColumnsType } from "./Stack-types";
import { toFlexDirection, toFlexJustifyOrAlignment } from "./Stack-helper";
import {
  PaddingProps,
  paddingProps,
  backgroundColorProps,
  BackgroundColorProps,
} from "@sloth-system/props";

export { StackContainer };

function defaultValues(props: any) {
  let {
    dir: direction = "horizontal",
    distribution = "start",
    alignment = "center",
    gap = 10,
    ...rest
  } = props;
  return { direction, distribution, alignment, gap, ...rest };
}
export function isColumnsAllowed(props): boolean {
  let { direction, columns } = defaultValues(props);
  if (direction === "vertical" || !Array.isArray(columns)) {
    return false;
  }
  return true;
}
function flexStyles(props: any) {
  let { direction, distribution, alignment } = defaultValues(props);
  let flexDirection = toFlexDirection(direction);
  let justifyContent = toFlexJustifyOrAlignment(distribution);
  let alignItems = toFlexJustifyOrAlignment(alignment);

  return `
    flex-direction: ${flexDirection};
    justify-content: ${justifyContent};
    align-items: ${alignItems};
  `;
}

function gapStyles(props: any) {
  let { distribution, direction, gap } = defaultValues(props);
  if (isGapDisabled(distribution)) {
    return "";
  }

  let margin = `margin: 0 0 0 0;`;
  let firstChildMargin = ``;
  let lastChildMargin = ``;
  if (direction === "horizontal") {
    margin = `margin: 0 ${gap / 2}px 0 ${gap / 2}px;`;
    firstChildMargin = `margin-right: 0;`;
    lastChildMargin = `margin-left: 0;`;
  } else {
    margin = `margin: ${gap / 2}px 0 ${gap / 2}px 0;`;
    firstChildMargin = `margin-top: 0;`;
    lastChildMargin = `margin-bottom: 0;`;
  }

  return `
    & > * {
      ${margin}
    }
    & > *:first-child {
      ${firstChildMargin}
    }
    & > *:last-child {
      ${lastChildMargin}
    }
  `;
}

function isGapDisabled(distribution: DistributionType) {
  return (
    distribution === "space-around" ||
    distribution === "space-between" ||
    distribution === "space-evenly"
  );
}

// columns doesn't have affect on vertical direction
function columns(props) {
  if (!isColumnsAllowed(props)) {
    return "";
  }
  let generatedCss = "flex-wrap: wrap;";
  return generatedCss;
}
var StackContainer = styled.View<
  PaddingProps & ColumnsType & BackgroundColorProps
>`
  display: flex;
  ${flexStyles}
  ${gapStyles}
  ${paddingProps}
  ${backgroundColorProps}
  ${columns}
`;
